<template>
  <main class="container_contact_desktop_contact_desktop">
    <div class="container_contact_desktop__div">
      <h1 class="container_contact_desktop__div__h1">Me contacter</h1>
    </div>

    <!-- formulaire -->
    <article class="container_contact_desktop__article">
      <!-- gauche -->
      <aside class="container_contact_desktop__article__aside_left">
        <form
          action="post"
          class="container_contact_desktop__article__aside_left__form"
          ref="form"
          @submit.prevent="sendMail"
          id="contact-form"
        >
          <!-- top -->
          <div
            class="container_contact_desktop__article__aside_left__form__div_top"
          >
            <input
              type="text"
              name="name"
              placeholder="Nom..."
              class="container_contact_desktop__article__aside_left__form__div_top__input_name"
              required
            />
            <input
              type="text"
              name="firstname"
              placeholder="Prénom..."
              class="container_contact_desktop__article__aside_left__form__div_top__input_firstname"
              required
            />
          </div>
          <!-- middle -->
          <div
            class="container_contact_desktop__article__aside_left__form__div_middle"
          >
            <div
              class="container_contact_desktop__article__aside__left__form__div_middle__div_left"
            >
              <input
                type="text"
                name="object"
                placeholder="Objet..."
                class="container_contact_desktop__article__aside_left__form__div_middle__div_left__input"
                required
              />
            </div>
            <!-- droite -->
            <div
              class="container_contact_desktop__article__aside_left__form__div_middle__div_right"
            >
              <div
                class="container_contact_desktop__article__aside_left__form__div_middle__div_right__top"
              >
                <input
                  type="submit"
                  name="envoyer"
                  id="envoyer"
                  value="Envoyer"
                  class="container_contact_desktop__article__aside_left__form__div_middle__div_right__top__input_envoyer"
                />
                <input
                  type="reset"
                  name="annuler"
                  id="annuler"
                  value="Annuler"
                  class="container_contact_desktop__article__aside_left__form__div_middle__div_right__top__input_annuler"
                />
              </div>

              <button
                style="display: block"
                onclick="document.getElementById('getFile').click()"
                class="container_contact_desktop__article__aside_left__form__div_middle__div_right__button"
              >
                Joindre fichier
              </button>
              <input
                type="file"
                id="getFile"
                style="display: none"
                class="container_contact_desktop__article__aside_left__form__div_middle__div_right___input_file"
              />
            </div>
          </div>
          <!-- bottom -->
          <div
            class="container_contact_desktop__article__aside_left__form__div_bottom"
          >
            <textarea
              name="message"
              id="message"
              cols="30"
              rows="10"
              placeholder="Message..."
              class="container_contact_desktop__article__aside_left__form__div_bottom__textarea"
              required
            >
            </textarea>
          </div>
        </form>
      </aside>

      <!-- droite -->
      <aside class="container_contact_desktop__article__aside_right">
        <!-- top -->
        <div class="container_contact_desktop__article__aside_right__div_top">
          <!-- top left -->
          <div
            class="container_contact_desktop__article__aside_right__div_top__div_left"
          >
            <!-- div vide -->
            <div
              class="container_contact_desktop__article__aside_right__div_top__div_left__div_vide_1"
            ></div>
            <!-- div text -->
            <div
              class="container_contact_desktop__article__aside_right__div_top__div_left__div_text"
            >
              <h2
                class="container_contact_desktop__article__aside_right__div_top__div_left__div_text__h2"
              >
                Localisation
              </h2>
            </div>
            <!-- div vide -->
            <div
              class="container_contact_desktop__article__aside_right__div_top__div_left__div_vide_2"
            ></div>
          </div>
          <!-- right -->
          <div
            class="container_contact_desktop__article__aside_right__div_top__div_right"
          >
            <img
              src="@/assets/map-icon.png"
              alt="map icon"
              class="container_contact_desktop__article__aside_right__div_top__div_right__img"
            />
          </div>
        </div>

        <!-- carte -->
        <div
          class="container_contact_desktop__article__aside_right__div_bottom"
        >
          <img
            src="@/assets/Ardèche-Position.svg"
            alt="Ardeche Position"
            class="container_contact_desktop__article__aside_right__div_bottom__img"
          />
        </div>
      </aside>
    </article>
  </main>
</template>

<script>
// import { reactive } from 'vue' // "from '@vue/composition-api'" if you are using Vue 2.x
// import useVuelidate from '@vuelidate/core'
// import { required, email } from '@vuelidate/validators'

export default {
  name: "ContactDesktop",

  // setup () {
  //   const form = reactive({
  //     name: '',
  //     firstname: '',

  //   })
  //   const rules = {
  //     firstName: { required }, // Matches form.firstName
  //     lastName: { required }, // Matches form.lastName
  //     contact: {
  //       email: { required, email } // Matches form.contact.email
  //     }
  //   }}
}

</script>

<style lang="scss" scoped>
@import "@/style/components/Contact/ContactDesktop.scss";

@media screen and(min-width: 926px) {
  .container_contact_desktop {
    display: none;
  }
}
</style>
